import { TipoEtapaTrackingEnum, TipoPagoBoleta } from 'config';
import { ColorModel } from 'models';
import { esDatoValido } from './trackingUtils';

/**
 * Función encargada de retornar el color de la línea
 * @param estado estado de la respuesta del servicio de facturacion
 * @returns retorna el color
 */
export const obtenerColorLinea = (estado: TipoPagoBoleta) => {
  switch (estado) {
    case TipoPagoBoleta.PAGADO:
      return 'verdeClaro';
    case TipoPagoBoleta.PENDIENTE_PAGO:
      return 'verdeClaro';
    case TipoPagoBoleta.VENCIDO:
      return 'rojo';
    default:
      return 'grisL63';
  }
};

/**
 * Función encargada de retornar el color de la etapa
 * @param estado estados de tracking
 * @returns retorna el color
 */
export const obtenerEstadoTomaLectura = (listadoEstados: any[]): ColorModel['color'] => {
  let color: ColorModel['color'] = 'grisL63';
  if (esDatoValido(listadoEstados)) {
    const matchLectura = listadoEstados
      .slice()
      .reverse()
      .find(item => item.estado === TipoEtapaTrackingEnum.LECTURA_EXITOSA || item.estado === TipoEtapaTrackingEnum.LECTURA_NO_EXITOSA);
    if (matchLectura) {
      if (matchLectura.estado === TipoEtapaTrackingEnum.LECTURA_EXITOSA) color = 'verdeOscuro';
      if (matchLectura.estado === TipoEtapaTrackingEnum.LECTURA_NO_EXITOSA) color = 'amarillo';
    }
  }
  return color;
};

/**
 * Función encargada de retornar el color de la etapa
 * @param estado estados de tracking
 * @returns retorna el color
 */
export const obtenerEstadoEntregaBoleta = (listadoEstados: any[]): ColorModel['color'] => {
  let color: ColorModel['color'] = 'grisL63';
  if (esDatoValido(listadoEstados)) {
    const matchLectura = listadoEstados
      .slice()
      .reverse()
      .find(item => item.estado === TipoEtapaTrackingEnum.BOLETA_ENTREGADA || item.estado === TipoEtapaTrackingEnum.BOLETA_NO_ENTREGADA);
    if (matchLectura) {
      if (matchLectura.estado === TipoEtapaTrackingEnum.BOLETA_ENTREGADA) color = 'verdeOscuro';
      if (matchLectura.estado === TipoEtapaTrackingEnum.BOLETA_NO_ENTREGADA) color = 'amarillo';
    }
  }
  return color;
};
